import { Component, OnInit } from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';
import { AppEventsService } from 'src/app/services/app-events.service';
import { UserService } from 'src/app/layouts/dash/modules/user-management/services/user.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { CompanyService } from 'src/app/services/company.service';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  constructor(
    private appEventsSvc: AppEventsService,
    private router: Router,
    private userSvc: UserService,
    public navigation: NavigationService,
    public companyService: CompanyService,
    private authSvc: AuthService
  ) { }
  role = 'Desconocido';
  user: any = null;
  image: string = 'assets/img/user.png';
  link = '/payments';
  companyName = '';
  type = '';

  ngOnInit(): void {
    this.user = JSON.parse(sessionStorage.getItem('user') || '');
    let role = sessionStorage.getItem('role');
    switch (role) {
      case 'SUPERADMIN':
        this.role = 'Super Administrador';
        break;
      case 'ADMIN':
        this.role = 'Administrador';
        break;
      case 'ENTERPRISE':
        this.role = 'Casa Matriz';
        break;
      case 'ENTERPRISE_POSTPAY':
        this.role = 'Casa Matriz';
        break;
      case 'CUSTOMER':
        this.role = 'Contratista';
        break;
      default:
        break;
    }
    this.setPhoto();
  }

  showSidebar() {
    this.appEventsSvc.setShowSidebar(true);
  }

  setPhoto() {
    this.userSvc.findOne(this.user._id).subscribe((data) => {
      if (data.photo) {
        this.image = data.photo;
      }
    });
    if (this.role == 'Casa Matriz' || this.role == 'Contratista') {
      this.companyService.getMatrix().subscribe((data) => {
        this.companyName = data.company.name;
        this.type = data.company.type;
      });
    }
  }

  logout() {
    this.authSvc.logout();
    this.router.navigate(['/auth']);
  }
}
